/** The different endpoint actions available for the Nomination route. */
export enum NominationActions {
  Actions = 'actions',
  Committees = 'committees',
  Hearings = 'hearings'
}
